import React, {useRef} from "react";

import PropTypes from "prop-types";
import styles from "./Services.scss";

import dedicated from "../../../img/Menu_icons/09_Menu_icon_Servers.svg";
import domains from "../../../img/Menu_icons/03_Menu_icon_Domains.svg";
import mvps from "../../../img/Menu_icons/07_Menu_icon_ManagedVPS.svg";
import search from "../../../img/Menu_icons/11_Menu_icon_Search.svg";
import siteBuilder from "../../../img/Menu_icons/05_Menu_icon_SiteBuilder.svg";
import shared from "../../../img/Menu_icons/01_Menu_icon_Hosting.svg";
import shop from "../../../img/Menu_icons/04_Menu_icon_Shopiko.svg";
import ssl from "../../../img/Menu_icons/06_Menu_icon_SSL.svg";
import vps from "../../../img/Menu_icons/08_Menu_icon_VPS.svg";
import wp from "../../../img/Menu_icons/02_Menu_icon_WP.svg";
import wpSupport from "../../../img/Menu_icons/menu-wpsupport.svg";
import wpAI from "../../../img/Menu_icons/WP_AI.svg";
import gdpr from "../../../img/Menu_icons/gdpr_icn_menu.svg";
import RenderIf from "../../common/primitives/RenderIf/RenderIf";
import {useOutseClickHook} from "../../common/hooks/useOutsideClickHook";
import {__t} from "../../common/lang/text-resource";

const Service = ({
					 page,
					 img,
					 alt,
					 isWPSupport,
					 text,
					 secondaryText,
					 isNewService,
					 nameMaxWidth
				 }) => {
	const isActive = window.location.pathname === page;

	const navigateToPage = () => {
		if (isActive) return;

		window.location = page;
	};

	return (
	  <div onClick={navigateToPage} className={isActive ? styles.active : null}>
		  <img src={img} alt={alt}/>

		  <RenderIf condition={isWPSupport !== true}>
			  <div className={styles.mainText} style={{maxWidth: nameMaxWidth}}>{text}</div>
			  <span>{secondaryText}</span>
		  </RenderIf>
		  <RenderIf condition={isWPSupport === true}>
			  <div className={styles.dinb}>{secondaryText}</div>
			  <div className={styles.mainText}>{text}</div>
		  </RenderIf>
		  <RenderIf condition={isNewService === true}>
			  <div className={styles.newService}>{__t("нова услуга")}</div>
		  </RenderIf>
	  </div>
	);
};
Service.propTypes = {
	page: PropTypes.string,
	img: PropTypes.string,
	alt: PropTypes.string,
	isWPSupport: PropTypes.bool,
	text: PropTypes.string,
	secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	isNewService: PropTypes.bool,
};

const Services = ({isMobile, toggleServices}) => {

	const lang = SHVO.pageLang ?? 'bg';

	const wrapperRef = useRef(null);

	useOutseClickHook(wrapperRef, toggleServices);

	const servicesMobileclass = isMobile ? styles.mobile : "";

	return (
	  <div ref={wrapperRef} className={`${styles.services} ${servicesMobileclass}`}>
		  <div className={styles.servicesContainer}>
			  <Service
				img={shared}
				alt={__t("Хостинг")}
				text={__t("Хостинг")}
				page="/web-hosting-compare-hosting-plans.php"
			  />
			  <Service
				img={wp}
				alt={__t("Wordpress")}
				text={__t("WordPress хостинг")}
				page="/wp-hosting.php"
			  />
			  <Service
				img={wpAI}
				alt={__t("Хостинг за WordPress + AI")}
				text={__t("Хостинг за WordPress + AI")}
				page="/managed-wp-hosting.php"
				nameMaxWidth={'170px'}
				isNewService={true}
			  />
			  <Service
				img={wpSupport}
				alt={__t("Професионална WordPress поддръжка")}
				text={__t("WordPress поддръжка")}
				secondaryText={__t("Професионална")}
				page="/wp-support.php"
				isWPSupport={true}
			  />
			  <Service
				img={domains}
				alt={__t("Домейни")}
				text={__t("Домейни")}
				page="/web-hosting-register-domains.php"
			  />

			  <Service
				img={shop}
				alt={__t("Онлайн магазин с включен хостинг")}
				text={__t("Онлайн магазин с Shopiko")}
				page="/web-hosting-compare-shop-plans.php"
			  />
			  <Service
				img={siteBuilder}
				alt={__t("Сайт Билдър")}
				text={__t("Сайт Билдър")}
				page="/site-builder.php"
			  />
			  <Service
				img={ssl}
				alt={__t("SSL")}
				text={__t("SSL сертификати")}
				page="/web-hosting-page-certificates.php"
			  />
			  <Service
				img={gdpr}
				alt={__t("GDPR Протект")}
				text={__t("GDPR Протект")}
				page="/gdpr-protect-iubenda"
				isNewService={true}
			  />
			  <Service
				img={mvps}
				alt={__t("MVPS")}
				text={isMobile ? __t("Managed VPS") : __t("Управляеми виртуални сървъри")}
				secondaryText={lang === 'bg' && __t("(Managed VPS)")}
				page="/web-hosting-common-managed-vps.php"
			  />

			  <Service
				img={vps}
				alt={__t("VPS като хостинг решение")}
				text={__t("Виртуални сървъри")}
				secondaryText={lang === 'bg' && __t("(VPS)")}
				page="/web-hosting-page-servers-vps.php"
			  />
			  <Service
				img={dedicated}
				alt={__t("Dedicated")}
				text={__t("Наети сървъри")}
				page="/web-hosting-page-servers-dedicated.php"
			  />
			  {/*https://jira.superhosting.bg/browse/MARKETING-73*/}
			  {/* <Service
          img={gadword}
          alt="Google Ads"
          text="Google Ads промо код"
          page= "/google-adwords.htm" 
        /> */}
			  {/*<Service
				img={search}
				alt={__t("Регистрация в търсачки")}
				text={__t("Регистрация в търсачки")}
				page="/web-hosting-page-search-registration.php"
			  />*/}
		  </div>
	  </div>
	);
};
Services.propTypes = {
	isMobile: PropTypes.bool.isRequired,
};

export default Services;